/* Preserve authored reviews; disclose only when they exceed three rendered lines. */
(() => {
  const entries = new Map(); let pending;
  /* Writes, then reads, then writes: one layout for the whole batch instead of one per review. */
  function measure(list) {
    list = list.filter(([body, entry]) => {
      if (body.isConnected) return true;
      entry.button.remove(); entries.delete(body); return false;
    });
    list.forEach(([body]) => { body.classList.add('cc-review-managed'); body.classList.remove('cc-review-collapsed'); });
    const sizes = list.map(([body]) => [parseFloat(getComputedStyle(body).lineHeight), body.getBoundingClientRect().height]);
    list.forEach(([body, entry], i) => {
      const [line, height] = sizes[i];
      const long = height > line * 3 + 2;
      body.style.setProperty('--review-preview-height', `${line * 3}px`);
      entry.button.hidden = !long;
      if (long && !entry.expanded) body.classList.add('cc-review-collapsed');
    });
  }
  const measureAll = () => measure([...entries]);
  function scan() {
    const added = [];
    document.querySelectorAll('.antilabs-reviews .jm-review-content__body, .antilabs-reviews .jdgm-rev__body, .antilabs-reviews__ssr-body').forEach(body => {
      if (entries.has(body)) return;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'cc-review-expand';
      button.textContent = 'Read full review'; button.setAttribute('aria-expanded', 'false');
      const entry = { button, expanded: false }; entries.set(body, entry);
      if (!body.id) body.id = 'review-copy-' + entries.size;
      button.setAttribute('aria-controls', body.id);
      body.insertAdjacentElement('afterend', button);
      button.addEventListener('click', () => {
        entry.expanded = !entry.expanded;
        button.setAttribute('aria-expanded', String(entry.expanded));
        button.textContent = entry.expanded ? 'Show less' : 'Read full review';
        measure([[body, entry]]);
      });
      added.push([body, entry]);
    });
    if (added.length) measure(added);
  }
  function start() {
    scan();
    new MutationObserver(records => {
      if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && !n.matches('.cc-review-expand')))) {
        clearTimeout(pending); pending = setTimeout(scan, 50);
      }
    }).observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
    let resize; addEventListener('resize', () => { clearTimeout(resize); resize = setTimeout(measureAll, 100); });
    document.fonts.ready.then(measureAll);
  }
  /* Reviews sit far down every page that has them: start as they come within
     1600 px of the screen, not during the page's first load (2026-09-24). */
  function wait() {
    const sections = document.querySelectorAll('.antilabs-reviews');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) { start(); return; }
    const watcher = new IntersectionObserver(seen => {
      if (!seen.some(entry => entry.isIntersecting)) return;
      watcher.disconnect(); start();
    }, {rootMargin: '1600px 0px'});
    sections.forEach(section => watcher.observe(section));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wait, {once: true}); else wait();
})();
